// Stylesheets
import './assets/scss/site.scss';

import { hover } from './assets/modules/hover';
import { trigger } from './assets/modules/trigger';
import { fluidvideo } from './assets/modules/fluidvideo';
import { popup } from './assets/modules/popup';
import { copyUrl } from './assets/modules/copyUrl';
import { initPhotoSwipeFromDOM } from './assets/modules/photoswipe-init';
import { swiperCarousel } from './assets/modules/swiperCarousel'
import { stickySidebarFunc } from './assets/modules/stickySidebar';
import { ytInit } from './assets/modules/ytInit';
import { popupYouTube } from './assets/modules/popupYouTube';
import { home } from './assets/modules/home';
import { letterFadeAnimate } from './assets/modules/letterFadeAnimate';
import { letterTypewriter } from './assets/modules/letterTypewriter';

const init = () => {
  hover();
  trigger();
  fluidvideo();
  popup();
  copyUrl();
  initPhotoSwipeFromDOM('.js-pswp-container');
  swiperCarousel();
  stickySidebarFunc();
  ytInit();
  popupYouTube();
  home();
  letterFadeAnimate();
  letterTypewriter();
}

init();